<form [formGroup]="filterForm"
  [ngClass]="{ 'flex-layout': true, 'filter-container': true, 'column': layoutDirection == 'column' }"
  class="sidebar-form">
  @if (showMinShipFilter) {
    <mat-form-field>
      <mat-label>From Ship Date</mat-label>
      <!--
      // we can only go forward in time as much as our to ship date, so make that our max
      [max]="filterForm.controls.toShipDateFilter.value"
      -->
      <input [min]="earliestShipDateShown"
        [max]="filterForm.controls.toShipDateFilter.value"
        formControlName="fromShipDateFilter"
        matInput
        [matDatepicker]="from_picker"
        (focus)="from_picker.open()"
        placeholder="Choose a date">
        <mat-datepicker-toggle matSuffix [for]="from_picker"></mat-datepicker-toggle>
        <mat-datepicker #from_picker></mat-datepicker>
      </mat-form-field>
    }

    @if (showMaxShipFilter) {
      <mat-form-field>
        <mat-label>To Ship Date</mat-label>
        <!--
        // we can only go back as far as the From date...so make that our minimum
        [min]="filterForm.controls.fromShipDateFilter.value"
        -->
        <input [min]="filterForm.controls.fromShipDateFilter.value"
          [max]="latestShipDateShown"
          formControlName="toShipDateFilter"
          matInput
          [matDatepicker]="to_picker"
          (focus)="to_picker.open()"
          placeholder="Choose a date">
          <mat-datepicker-toggle matSuffix [for]="to_picker"></mat-datepicker-toggle>
          <mat-datepicker #to_picker></mat-datepicker>
        </mat-form-field>
      }

      @if (showMinShipFilter) {
        <div class="flex-layout no-wrap date-range-buttons">
          <button mat-raised-button (click)="changeShipDatesToToday()" title="Range shows orders shipping today, or in the past">
            <mat-icon>info</mat-icon>
            <span>Today</span>
          </button>
          <button title="The max allowable date range is 30 days in the past and 14 days in the future" mat-raised-button (click)="changeShipDatesToAny()">
            <mat-icon>info</mat-icon>
            <span>Max</span>
          </button>
        </div>
      }

      @if (showCheckboxFilters) {
        <mat-checkbox formControlName="warningsErrorsFilter">Warnings/Errors Only</mat-checkbox>
        <mat-checkbox formControlName="cancelledOrdersFilter">Hide Cancelled Orders</mat-checkbox>
      }

      @if (showOrderSourceSystemFilter) {
        <mat-form-field>
          <mat-label>Order Source System</mat-label>
          <mat-select formControlName="orderSourceSystemFilter">
            @for (orderSourceSystem of orderSourceSystemFilterTypes; track orderSourceSystem) {
              <mat-option [value]="orderSourceSystem.index">{{orderSourceSystem.displayName}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      @if (showOrderFilter) {
        <mat-form-field class="order-types-filter">
          <mat-label>Order Types</mat-label>
          <mat-select formControlName="orderTypeFilter" multiple>
            <mat-select-trigger>
              @if (filterForm.controls.orderTypeFilter.value?.length > 1) {
                <span>
                  {{ filterForm.controls.orderTypeFilter.value.length }} selected
                </span>
              } @else {
                {{  orderUtilityService.mapOrderOrderType( filterForm.controls.orderTypeFilter.value[0])  }}
              }
            </mat-select-trigger>
            @for (order of orderFilterTypes; track order) {
              <mat-option [value]="order.index">{{order.displayName}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      @if (showMediaFilter) {
        <mat-form-field>
          <mat-label>Media Types</mat-label>
          <mat-select formControlName="mediaFilter" multiple>
            <mat-select-trigger>
              @if (filterForm.controls.mediaFilter.value?.length > 1) {
                <span>
                  {{ filterForm.controls.mediaFilter.value.length }} selected
                </span>
              } @else {
                {{  orderUtilityService.mapOrderMediaType(filterForm.controls.mediaFilter.value[0])  }}
              }
            </mat-select-trigger>
            @for (media of mediaFilterTypes; track media) {
              <mat-option [value]="media.index">{{media.displayName}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      @if (showStatusFilter) {
        <mat-form-field>
          <mat-label>Status</mat-label>
          <mat-select formControlName="statusFilter">
            @for (status of statusFilterTypes; track status) {
              <mat-option [value]="status.index">{{status.displayName}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      @if (showErrorFilter) {
        <mat-form-field>
          <mat-label>Error Types</mat-label>
          <mat-select formControlName="errorFilter" multiple>
            <mat-select-trigger>
              @if (filterForm.controls.errorFilter.value?.length > 1) {
                <span>
                  {{ filterForm.controls.errorFilter.value.length }} selected
                </span>
              } @else {
                {{  orderUtilityService.mapOrderErrorType(filterForm.controls.errorFilter.value[0])  }}
              }
            </mat-select-trigger>
            @for (error of errorFilterTypes; track error) {
              <mat-option [value]="error.index">
                <span [attr.error-type]="getErrorAbbreviation(error.index)">{{error.displayName}}</span>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      @if (showDrmFilter) {
        <mat-form-field>
          <mat-label>DRM Type</mat-label>
          <mat-select formControlName="drmFilter">
            @for (drmType of drmFilterTypes; track drmType) {
              <mat-option [value]="drmType.index">{{drmType.displayName}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </form>
